import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { StreamlineIcon } from '@unowmooc/react-ui-kit'

import styles from './styles.module.scss'

class DragControl extends Component {
  constructor() {
    super()

    this.handleMouseDown = this.handleMouseDown.bind(this)
    this.handleMouseLeave = this.handleMouseLeave.bind(this)

    this.state = { mouseDown: false }
  }

  handleMouseDown(event) {
    this.setState({ mouseDown: true })

    const { onMouseDown } = this.props

    if (onMouseDown) {
      onMouseDown(event)
    }
  }

  handleMouseLeave(event) {
    this.setState({ mouseDown: false })

    const { onMouseLeave } = this.props

    if (onMouseLeave) {
      onMouseLeave(event)
    }
  }

  render() {
    const { dragging, className, ...rest } = this.props
    const { mouseDown } = this.state

    return (
      <StreamlineIcon
        {...rest}
        onMouseDown={this.handleMouseDown}
        onMouseLeave={this.handleMouseLeave}
        icon="9dots"
        className={classnames(styles.dragControl, { [styles.dragging]: dragging || mouseDown }, className)}
      />
    )
  }
}

DragControl.defaultProps = {
  onMouseLeave: undefined,
  onMouseDown: undefined,
  dragging: false,
  className: undefined,
}

DragControl.propTypes = {
  onMouseLeave: PropTypes.func,
  onMouseDown: PropTypes.func,
  dragging: PropTypes.bool,
  className: PropTypes.string,
}

export default DragControl
